import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import { ReactComponent as SortIcon } from "./../../../../assets/svg/sort.svg";
import FilterSidebar from "./FilterSidebar/FilterSidebar";
import SortModal from "./SortModal/SortModal";
import useFilter from "./useFilter";
import useSort from "./useSort";

import { ReactComponent as CancelIcon } from "./../../../../assets/svg/cancel.svg";
import { ReactComponent as FilterIcon } from "./../../../../assets/svg/filter.svg";
import Button from "../../ui/Button";

const FilterSort = (props) => {
  const { city_id, category_id } = props;

  const [filter_open, set_filter_open] = useState(false);

  const [
    filter_list,
    set_filter_list,
    checkbox_change,
    clear_filter,
    submit_filter,
    current_filters,
    delete_filter,
  ] = useFilter(city_id, category_id, set_filter_open);

  const [
    sort_modal,
    set_sort_modal,
    active_sort,
    set_active_sort,
    sort_list,
    activeSortLabel,
  ] = useSort();

  useEffect(() => {
    if (filter_open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [filter_open]);

  return (
    <div className={"filter-sort-container"}>
      <div className={"filter-container"}>
        <div
          style={{ flexGrow: 1, flexBasis: 0 }}
          className={"filter-container-filter-button mt-2"}
        >
          <Button
            style_justifyContent="flex-start"
            style_width="100%"
            style_border="type-5"
            style_border_active="none"
            style={{
              boxShadow: "0px 0px 6px 1px rgb(0 0 0 / 10%)",
              display: "flex",
              alignItems: "flex-start",
              gap: "8px",
            }}
            style_marginRight={8}
            style_backgroundColor="white"
            style_color="type-black-2"
            style_color_hover="type-black-2"
            style_color_active="type-black-2"
            style_fontSize="type-3"
            style_paddingLeft={"type-2"}
            style_paddingRight={"type-2"}
            style_borderRadius="type-2"
            onClick={() => set_filter_open(!filter_open)}
            // className={"filter-button"}
          >
            <FilterIcon width={16} height={16} />
            <span>Filter</span>
          </Button>
        </div>
        <div className={"filter-container-sort-button mt-2"}>
          <Button
            style_justifyContent="flex-start"
            style_width="100%"
            style_border="type-5"
            style={{ boxShadow: "0px 0px 6px 1px rgb(0 0 0 / 10%)" }}
            style_marginRight={8}
            style_backgroundColor="white"
            style_color="type-black-2"
            style_color_hover="type-black-2"
            style_color_active="type-black-2"
            style_fontSize="type-3"
            style_paddingTop="type-0"
            style_paddingBottom="type-0"
            style_paddingLeft="type-2"
            style_paddingRight="type-2"
            style_borderRadius="type-2"
            onClick={() => set_sort_modal(true)}
            className={"sort-button"}
          >
            <div>
              <span className="sort-text">
                Sort <span className="sort-item">({activeSortLabel})</span>
                {/* مرتب سازی:{" "}
                {
                  sort_list.find((sort_item) => sort_item.key === active_sort)
                    .label
                } */}
              </span>
            </div>
            {/* <ArrowIcon /> */}
          </Button>
        </div>
      </div>
      {current_filters && current_filters.length > 0 && (
        <div className={"current-filters-container"}>
          {current_filters.map((filter_item) => {
            return (
              <div
                onClick={() =>
                  delete_filter(filter_item.key, filter_item.parent_key)
                }
                key={filter_item.key}
                className={"current-filter-item-container"}
              >
                <span>{filter_item.label}</span>
                <CancelIcon />
              </div>
            );
          })}
        </div>
      )}

      <FilterSidebar
        filter_open={filter_open}
        set_filter_open={set_filter_open}
        clear_filter={clear_filter}
        filter_list={filter_list}
        set_filter_list={set_filter_list}
        checkbox_change={checkbox_change}
        submit_filter={submit_filter}
      />

      <SortModal
        active_sort={active_sort}
        set_active_sort={set_active_sort}
        sort_modal={sort_modal}
        set_sort_modal={set_sort_modal}
        sort_list={sort_list}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    city_id: state.Login.city_id,
  };
};

export default connect(mapStateToProps)(FilterSort);
